import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export enum UfoExperiences {
	SLACK_SEGMENT_RENDERED = 'slack-segment-rendered',
	SLACK_REQUEST_SENT = 'slack-request-sent',
	SLACK_FORM_ENABLED = 'share-form-enabled',
	PLATFORM_SLACK_USERS_PAGE_FETCHED = 'platform-slack-users-page-fetched',
}

export type CustomData = {
	[key: string]: string | number | boolean | CustomData | undefined;
};

enum PlatformComponent {
	ShareToSlack = 'share-to-slack',
	CoreInvites = 'core-invites',
}

export const ufoExperiences: Record<UfoExperiences, UFOExperience> = {
	[UfoExperiences.SLACK_REQUEST_SENT]: new UFOExperience(UfoExperiences.SLACK_REQUEST_SENT, {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		platform: { component: PlatformComponent.ShareToSlack },
	}),
	[UfoExperiences.SLACK_SEGMENT_RENDERED]: new UFOExperience(
		UfoExperiences.SLACK_SEGMENT_RENDERED,
		{
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
			platform: { component: PlatformComponent.ShareToSlack },
		},
	),
	[UfoExperiences.SLACK_FORM_ENABLED]: new UFOExperience(UfoExperiences.SLACK_FORM_ENABLED, {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.Custom,
		platform: { component: PlatformComponent.ShareToSlack },
	}),
	[UfoExperiences.PLATFORM_SLACK_USERS_PAGE_FETCHED]: new UFOExperience(
		UfoExperiences.PLATFORM_SLACK_USERS_PAGE_FETCHED,
		{
			type: ExperienceTypes.Load,
			performanceType: ExperiencePerformanceTypes.Custom,
			platform: { component: PlatformComponent.CoreInvites },
		},
	),
};

export const startUfoExperience = (
	experienceName: UfoExperiences,
	properties?: CustomData,
): void => {
	const experience = ufoExperiences[experienceName];
	experience.start();
	if (properties) {
		experience.addMetadata(properties);
	}
};

export const succeedUfoExperience = (
	experienceName: UfoExperiences,
	properties?: CustomData,
): void => {
	const experience = ufoExperiences[experienceName];
	experience.success({ metadata: properties });
};

export const failUfoExperience = (
	experienceName: UfoExperiences,
	properties?: CustomData,
): void => {
	const experience = ufoExperiences[experienceName];
	experience.failure({ metadata: properties });
};

export const abortUfoExperience = (
	experienceName: UfoExperiences,
	properties?: CustomData,
): void => {
	const experience = ufoExperiences[experienceName];
	experience.abort({ metadata: properties });
};
